import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { setChangedParam } from "./URLUtils";

/**
 * Hook, welcher Veränderungen eines Pfadparameters propagiert.
 * @param paramName Der Name des Parameters
 * @param paramType Der Typ des Parameters (siehe Konstanten der URLUtils).
 * @param missingValue Der Wert, welcher ausgegeben werden soll, wenn der Parameter keinen gültigen Wert hat
 * @returns  den Wert des Parameters
 */
function usePathParam(paramName, paramType = null, missingValue = null) {
    const innerParamValue = useParams()[paramName];

    const [paramValue, setParamValue] = useState();

    useEffect(() => {
        setChangedParam(innerParamValue, paramType, missingValue, paramValue, setParamValue);
    }, [innerParamValue, paramName, paramValue, missingValue, paramType]);

    return paramValue;
}

export default usePathParam;
